<template>
    <div class="d-flex align-items-center py-3 py-md-1 justify-content-end">
        <div class=""><!--begin::Menu--><a href="javascript:;"
                class="btn btn-bg-white btn-active-color-primary fw-bolder btn-color-app" data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"><span class="svg-icon svg-icon-5 svg-icon-gray-500 me-1">

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#344054" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>{{ $t('filter') }}</a><!--begin::Menu 1-->
            <div class="menu menu-sub menu-sub-dropdown w-250px w-md-500px" data-kt-menu="true"
                id="kt_menu_624453e0495ae" style=""><!--begin::Header-->
                <div class="px-7 py-5">
                    <div class="fs-5 text-dark fw-bolder">{{ $t('filterOptions') }}</div>
                </div><!--end::Header--><!--begin::Menu separator-->
                <div class="separator border-gray-200"></div><!--end::Menu separator--><!--begin::Form-->
                <div class="px-7 py-5 adv_filter_container overflow-scroll datatable_filter_container">
                    <form id="datatable_filter">
                        <div class="row">
                            <div :class="`${index === filters.length - 1 && filters.length%2 != 0 ? 'col-md-12' : 'col-md-6'}`" v-for="filter, index in filters" :key="index">
                                <div class="form-group mb-4" v-if="filter.type == 'text'"><label :for="filter.name"
                                        class="form-label">{{ filter.label }}</label><input type="text"
                                        :id="filter.name" v-model="form[filter.name]" :name="filter.name"
                                        class="form-control"></div>

                                <div class="form-group mb-4" v-else-if="filter.type == 'select'"><label for="status"
                                        class="form-label">{{ filter.label }}</label>
                                    <div class="">
                                        <Select2 v-model="form[filter.name]" :options="filter.options"
                                            :settings="filter.settings" :name="filter.name" />
                                    </div>
                                </div>
                                <div class="form-group mb-4" v-else-if="filter.type == 'number'">
                                    <label :for="filter.name" class=" form-label">{{ filter.label }}</label>
                                    <input type="number" :name="filter.name" :id="filter.name" class="form-control"
                                        v-model="form[filter.name]" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <button type="reset"
                                class="btn-light mx-2 align-items-center border border-secondary btn-white d-flex fs-6 h-40px justify-content-center rounded-3 text-dark w-auto px-4 btnReset"
                                @click="reset">{{
                                $t('reset') }}</button>
                            <button type="button"
                                class="add-main-color align-items-center border border-secondary btn-white d-flex fs-6 h-40px justify-content-center rounded-3 text-dark text-white w-auto px-4"
                                ref="applyBtn" @click="apply">{{
                                $t('apply') }}</button>
                        </div>
                    </form>
                </div><!--end::Form-->
            </div><!--end::Menu 1--><!--end::Menu-->
        </div><!--end::Wrapper-->
    </div><!--end::Actions-->
</template>

<script>
import Select2 from 'vue3-select2-component';
export default {
    components: { Select2 },
    props: {
        filters: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            form: {}
        }
    },
    methods: {
        apply() {
            this.$emit('apply', this.form);  // Emit the form data to the parent
        },
        reset() {
            this.form = {}
            $('.select2-hidden-accessible').empty().trigger('change')
            setTimeout(() => {
            this.$refs.applyBtn.click()
            },100)
        }
    },
};
</script>

<style lang="scss" >
span.select2.select2-container {
    width: 100% !important;
}</style>
